import { render, staticRenderFns } from "./gc-wo-bulk-update-material-config.vue?vue&type=template&id=0f7b0f6e"
import script from "./gc-wo-bulk-update-material-config.vue?vue&type=script&lang=js"
export * from "./gc-wo-bulk-update-material-config.vue?vue&type=script&lang=js"
import style0 from "./gc-wo-bulk-update-material-config.vue?vue&type=style&index=0&id=0f7b0f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports